import React from 'react';
import { PageType } from '../google-analytics/tracking';

export type PageContextTypes = {
  pageType: PageType;
};

export const PageContext = React.createContext<PageContextTypes>({ pageType: null });
